import React from 'react';
import { View } from 'react-native';
import { useModal } from 'react-native-modalfy';
import { observer } from 'mobx-react-lite';

import { IconTouchable } from '../../common/IconTouchable';
import { OptionsMenuPopover } from '../../views/OptionsMenuPopover';
import { usePopover } from '@hooks';
import { modals, ModalStackParamsType } from '@modals';
import type { ICommentActionMenuProps } from './CommentActionMenu';
import { useCommentActionMenu } from './hooks/useCommentActionMenu';

/**
 * We are using the separate component for web platform because we are using NavigationContext
 * in this component which causes app crash because CommentItem can be used in modal components
 * where this context is not available, but for web we do not need NavigationContext so we
 * created the separate component without using NavigationContext
 */
export const CommentActionMenu = observer<ICommentActionMenuProps>(
  ({ item, onPressEdit }) => {
    const popover = usePopover();
    const modal = useModal<ModalStackParamsType>();
    const options = useCommentActionMenu({
      item,
      navigateToReport,
      onPressEdit,
    });

    function openMenu() {
      popover.togglePopover();
    }

    function navigateToReport() {
      modal.openModal(modals.ReportModal, {
        item,
      });
    }

    return (
      <View>
        <OptionsMenuPopover ref={popover.ref} items={options}>
          <IconTouchable
            size={20}
            name="point-vertical"
            onPress={openMenu}
          />
        </OptionsMenuPopover>
      </View>
    );
  },
);
